import { IGetProfileRequestAction, ProfileTypes } from "./profile.type";

export const getProfile = (): IGetProfileRequestAction => ({
  type: ProfileTypes.GET_PROFILE,
});
